(function(){
  var I = window.GM_I18N || {};
  // Cart drawer
  var drawer = document.querySelector('[data-drawer]');
  document.addEventListener('click', function(e){
    if(e.target.closest('[data-drawer-open]')){ if(drawer) drawer.setAttribute('open',''); }
    if(e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer__scrim')){ if(drawer) drawer.removeAttribute('open'); }
  });

  // PDP variant selection
  document.querySelectorAll('[data-product]').forEach(function(root){
    var dataEl = root.querySelector('[data-variants]');
    if(!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var atc = root.querySelector('[data-atc]');
    var groups = root.querySelectorAll('[data-opt-group]');
    var main = root.querySelector('[data-gallery-main]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    var selected = [];

    /* Startauswahl = Variante, die Shopify ausgeliefert hat (z. B. aus ?variant=).
       Vorher wurde immer der jeweils erste Wert markiert. */
    var startId = idInput ? parseInt(idInput.value, 10) : null;
    var startV = variants.find(function(v){ return v.id === startId; });
    groups.forEach(function(g,i){
      var want = startV ? startV['option'+(i+1)] : null;
      var btn = null;
      g.querySelectorAll('.opt__btn').forEach(function(b){ if(!btn && want !== null && b.getAttribute('data-value') === want) btn = b; });
      if(!btn) btn = g.querySelector('.opt__btn');
      selected[i] = btn ? btn.getAttribute('data-value') : null;
      if(btn) btn.classList.add('on');
    });

    /* Preise im selben Format wie im restlichen Shop (Shopify-Einstellung „Währung formatieren“) */
    function money(cents){
      cents = parseInt(cents, 10) || 0;
      var format = window.GM_MONEY_FORMAT || '{{amount_with_comma_separator}} €';
      function fmt(n, dec, th, ds){
        var parts = (n / 100).toFixed(dec).split('.');
        var ints = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
        return parts[1] ? ints + ds + parts[1] : ints;
      }
      var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
      var key = m ? m[1] : 'amount';
      var val;
      switch(key){
        case 'amount_with_comma_separator': val = fmt(cents, 2, '.', ','); break;
        case 'amount_no_decimals': val = fmt(cents, 0, ',', '.'); break;
        case 'amount_no_decimals_with_comma_separator': val = fmt(cents, 0, '.', ','); break;
        case 'amount_with_apostrophe_separator': val = fmt(cents, 2, "'", '.'); break;
        default: val = fmt(cents, 2, ',', '.');
      }
      return format.replace(/\{\{\s*\w+\s*\}\}/, val);
    }

    /* Produktbild auf das Variantenbild umschalten */
    function path(u){ return String(u || '').split('?')[0].replace(/^https?:/, ''); }
    function showImage(img){
      if(!img || !main) return;
      var src = img.src || '';
      if(!src) return;
      if(src.indexOf('//') === 0) src = 'https:' + src;
      var full = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1400';
      var hit = null;
      thumbs.forEach(function(t){ if(!hit && path(t.getAttribute('data-full')) === path(src)) hit = t; });
      if(hit) full = hit.getAttribute('data-full');
      if(path(main.getAttribute('src')) !== path(full)) main.src = full;
      thumbs.forEach(function(x){ x.classList.toggle('on', x === hit); });
    }
    function match(){
      return variants.find(function(v){
        return selected.every(function(val,i){ return !val || v['option'+(i+1)]===val; });
      });
    }
    function update(fromClick){
      var v = match();
      if(v){
        if(idInput) idInput.value = v.id;
        if(fromClick){
          showImage(v.featured_image);
          if(window.history && history.replaceState){
            var url = new URL(location.href);
            url.searchParams.set('variant', v.id);
            history.replaceState(history.state, '', url.toString());
          }
        }
        if(priceEl) priceEl.firstChild ? priceEl.firstChild.nodeValue = money(v.price) : priceEl.textContent = money(v.price);
        if(atc){ atc.disabled = !v.available; atc.textContent = v.available ? (atc.getAttribute('data-label')||I.addToCart||'In den Warenkorb') : (I.soldOut||'Ausverkauft'); }
      } else if(atc){ atc.disabled = true; atc.textContent = I.unavailable||'Nicht verfügbar'; }
    }
    groups.forEach(function(g,i){
      g.querySelectorAll('.opt__btn').forEach(function(btn){
        btn.addEventListener('click', function(){
          selected[i] = btn.getAttribute('data-value');
          g.querySelectorAll('.opt__btn').forEach(function(b){ b.classList.remove('on'); });
          btn.classList.add('on');
          update(true);
        });
      });
    });
    update();
    /* Aufruf mit ?variant= (z. B. aus einer Anzeige): passendes Bild gleich zeigen */
    if(startV && /[?&]variant=/.test(location.search)) showImage(startV.featured_image);

    // Gallery thumbs
    thumbs.forEach(function(t){
      t.addEventListener('click', function(){
        if(main) main.src = t.getAttribute('data-full');
        root.querySelectorAll('[data-thumb]').forEach(function(x){ x.classList.remove('on'); });
        t.classList.add('on');
      });
    });
  });

  // Shipping countdown to a cutoff hour
  document.querySelectorAll('[data-countdown]').forEach(function(el){
    var cutoff = parseInt(el.getAttribute('data-countdown'),10) || 17;
    function tick(){
      var now = new Date();
      var end = new Date(); end.setHours(cutoff,0,0,0);
      if(end < now) end.setDate(end.getDate()+1);
      var d = Math.max(0, end - now);
      var h = Math.floor(d/3.6e6), m = Math.floor(d%3.6e6/6e4), s = Math.floor(d%6e4/1e3);
      el.textContent = (h<10?'0':'')+h+'h '+(m<10?'0':'')+m+'m '+(s<10?'0':'')+s+'s';
    }
    tick(); setInterval(tick,1000);
  });

  // Dynamic shipping/delivery dates (today + offset), German DD.MM.
  (function(){
    function fmt(d){ return ('0'+d.getDate()).slice(-2)+'.'+('0'+(d.getMonth()+1)).slice(-2)+'.'; }
    document.querySelectorAll('[data-date-offset]').forEach(function(el){
      var off = parseInt(el.getAttribute('data-date-offset'),10)||0;
      var d = new Date(); d.setDate(d.getDate()+off);
      el.textContent = fmt(d);
    });
  })();
})();
